<template>
  <div class="mk-organisationgalleries col-12 p-0">

    <div class="container-fluid mb-4 px-0">
      <div class="row mx-0">

        <div class="col-12 px-0">
          <div class="gallery-card dashboard-card">

            <div
              class="
                mb-4
                px-0
                d-flex
                flex-column flex-md-row
                justify-content-start justify-content-md-between
                align-items-md-center align-items-start
              "
            >
              <h3 class="ml-0 mb-0 mb-3">Galleries</h3>

              <div class="d-flex flex-column flex-md-row">
                <a
                  @click="addNewItem"
                  class="btn btn-secondary mb-3 mb-md-0 ml-md-3"
                >
                  New Gallery
                </a>
              </div>
            </div>

            <paginated-table :headers="headers" ref="paginationRef">
            </paginated-table>

            <v-dialog v-model="dialog" max-width="600px" scrollable overlay-opacity="0.8" overlay-color="#000">
              <v-card class="mk-org-galleries-modal hf-dialog">
                <v-card-title>
                  <div
                    class="
                      w-100
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <h2 class="mb-0">
                      {{ gallery.id ? "Edit" : "Create" }} Gallery
                    </h2>

                    <button
                      @click="dialog = false"
                      class="btn btn-close-modal"
                      text
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </v-card-title>

                <v-card-text class="py-0">
                  <v-container class="admin-input-wrap">
                    <v-row>
                      <v-col cols="12">
                        <label>Name</label>
                        <v-text-field
                          outlined
                          v-model="gallery.name"
                          placeholder=""
                          class="text-field"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Address</label>
                        <vue-google-autocomplete
                            ref="address"
                            id="map"
                            classname="form-control"
                            placeholder="Please type an address"
                            v-model="gallery.address"
                            v-on:placechanged="getAddressData"
                            country="au"
                            >
                        </vue-google-autocomplete>
                        <p class="small">If no location is selected, users are able to leave perspective who are not viewing the art in the gallery.</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        class="d-flex justify-content-between align-items-start mt-2"
                      >
                        <label class="mb-0">Geolocation</label>
                        <v-switch
                          :label="geolocationStatus"
                          v-model="gallery.is_enabled_geolocation"
                          inset
                          color="var(--color-green)"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <button
                            @click="dialog = false"
                            class="btn btn-grey"
                            text
                          >
                            Cancel
                          </button>

                          <button
                            @click="saveItem"
                            color="primary"
                            text
                            class="btn btn-success"
                          >
                            Save
                          </button>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Gallery from "../../models/Gallery";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: { VueGoogleAutocomplete },
  props: {
    organisation: {
      type: Object,
    },
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Address", value: "address" },
        { text: "Geolocation", value: "enabled_geoLocation_text", sortable: false},
        {
          text: "# of Exhibitions",
          value: "exhibitions",
          formatter: "count",
          sortable: false,
        },
        {
          text: "# of Artwork",
          value: "artworks",
          formatter: "count",
          sortable: false,
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      gallery: new Gallery({}),
    };
  },
  computed: {
    geolocationStatus: function () {
      return this.gallery.is_enabled_geolocation ? "Enabled" : "Disabled";
    }
  },
  methods: {
    async getModelDetails() {
      return Gallery.where("organisation_id", this.organisation.id).include(
        "exhibitions",
        "artworks"
      );
    },

    addNewItem() {
      this.gallery = new Gallery({});
      this.dialog = true;
    },

    saveItem() {
      this.gallery.organisation_id = this.organisation.id;
      this.gallery.save().then((response) => {
        if (!response.data) {
          this.dialog = false;
          this.$refs.paginationRef.readDataFromAPI();
        }
      });
    },

    editItem(data) {
      this.dialog = true;
      this.gallery = data;
    },

    deleteItem(data) {
      this.gallery = data;
      this.$swal({
        title: "Are you sure you want to delete this?",
        customClass: {
          confirmButton: "order-2 btn btn-danger ml-1",
          cancelButton: "order-1 btn hf-btn-secondary mr-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        iconHtml: "",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let gallery = new Gallery(this.gallery);
          gallery.delete().then((response) => {
            this.$refs.paginationRef.readDataFromAPI();

            Vue.swal({
              title: " ",
              text: "Deleted",
              icon: "success",
              toast: true,
              position: "top-end",
              timer: 2000,
              showConfirmButton: false,
            });
          });
        }
      });
    },

    /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      getAddressData: function (addressData, placeResultData, id) {
        if(placeResultData) {
            this.gallery.address = placeResultData.formatted_address;
        }

        console.log(placeResultData);

        if(addressData) {
            if(addressData.route !== undefined) this.gallery.street = addressData.route;
            if(addressData.street_number !== undefined) this.gallery.street_number = addressData.street_number;
            if(addressData.administrative_area_level_1 !== undefined) this.gallery.state = addressData.administrative_area_level_1;
            if(addressData.locality !== undefined) this.gallery.locality = addressData.locality;
            if(addressData.postal_code !== undefined) this.gallery.postal_code = addressData.postal_code;

            this.gallery.country = addressData.country;
            this.gallery.latitude = addressData.latitude;
            this.gallery.longitude = addressData.longitude;
        }
      },
  },
};
</script>
